/**
 * The initial value of Symbol.toStringTag is the well-known symbol @@toStringTag
 * https://tc39.es/ecma262/#sec-symbol.tostringtag
 */
export const symbolToStringTag = () => Symbol("Symbol.toStringTag");
